export const errorBoundary = {
  emoji: '🤦‍♂️',
  title: 'Oops! Something broke',
  subtitle: 'It seems the app had one too many coffees and is now a bit dizzy',
  technicalErrorLabel: 'Technical error (for the nerds):',
  unknownError: 'Unknown error (ghost in the machine?)',
  solutionsIntro: "Don't worry, these things happen. Try one of these magical solutions:",
  solutions: {
    turnOffOn: 'Turn it off and on (the classic that never fails)',
    pray: 'Pray to the coding gods',
    clearCache: 'Clear cookies and cache (just because)',
    contactSupport: "Contact support (we're confused too)",
  },
  buttons: {
    goHome: '🔄 Back to home',
    goBack: '← Go back',
    reload: '♻️ Reload page',
  },
  footer: "If the error persists, it's probably Mercury in retrograde 🪐",
  chunk: {
    updating: 'Updating to the latest version…',
    title: 'A new version is available',
    subtitle: 'We updated the app. Reload the page to continue.',
    reload: 'Reload page',
  },
} as const
